export default "__VITE_ASSET__5qAnYI4a__"